"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Origin = void 0;
var Origin;
(function (Origin) {
    Origin["VIDEOBLOCKS"] = "VIDEOBLOCKS";
    Origin["AUDIOBLOCKS"] = "AUDIOBLOCKS";
    Origin["GRAPHICSTOCK"] = "GRAPHICSTOCK";
    Origin["STORYBLOCKS"] = "STORYBLOCKS";
    Origin["STORYBLOCKS_NEXTJS"] = "STORYBLOCKS_NEXTJS";
    Origin["CONTRIBUTOR_PORTAL"] = "CONTRIBUTOR_PORTAL";
    Origin["TEMPLATE_EDITOR"] = "TEMPLATE_EDITOR";
    Origin["ACCOUNT_SERVICE"] = "ACCOUNT_SERVICE";
    Origin["BILLING_SERVICE"] = "BILLING_SERVICE";
    Origin["CONTENT_SERVICE"] = "CONTENT_SERVICE";
    Origin["PAYOUT_SERVICE"] = "PAYOUT_SERVICE";
    Origin["TRANSLATION_SERVICE"] = "TRANSLATION_SERVICE";
    Origin["CONTENT_RATING_APP"] = "CONTENT_RATING_APP";
    Origin["FEATURE_FLAG_SERVICE"] = "FEATURE_FLAG_SERVICE";
    Origin["PREMIERE_PRO_PLUGIN"] = "PREMIERE_PRO_PLUGIN";
    Origin["AFTER_EFFECTS_PLUGIN"] = "AFTER_EFFECTS_PLUGIN";
    Origin["EXAMPLE_SERVICE"] = "EXAMPLE_SERVICE";
    Origin["SEARCH_SERVICE"] = "SEARCH_SERVICE";
    Origin["CONTENT_JOB"] = "CONTENT_JOB";
    Origin["DATA_JOB"] = "DATA_JOB";
    Origin["MISC"] = "MISC";
    Origin["STORYBOARD"] = "STORYBOARD";
    Origin["USER_SERVICE"] = "USER_SERVICE";
    Origin["SUBSCRIPTION_SERVICE"] = "SUBSCRIPTION_SERVICE";
    Origin["OUTDATED_SCHEMA"] = "OUTDATED_SCHEMA";
})(Origin || (exports.Origin = Origin = {}));
//# sourceMappingURL=OriginEnum.js.map